var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "relative rounded-sm sm:text-sm sm:leading-5 bg-inherit" },
    [
      _vm.prefix
        ? _c(
            "div",
            {
              staticClass:
                "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none",
            },
            [
              _vm._t("prefix", function () {
                return [
                  _c(
                    "span",
                    { staticClass: "text-gray-500", class: _vm.prefixClasses },
                    [_vm._v(" " + _vm._s(_vm.prefix) + " ")]
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "FormInput",
        _vm._g(
          _vm._b({ class: _vm.inputClasses }, "FormInput", _vm.$attrs, false),
          _vm.$listeners
        )
      ),
      _vm.suffix
        ? _c(
            "div",
            {
              staticClass:
                "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none",
            },
            [
              _vm._t("suffix", function () {
                return [
                  _c(
                    "span",
                    { staticClass: "text-gray-500", class: _vm.suffixClasses },
                    [_vm._v(" " + _vm._s(_vm.suffix) + " ")]
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm.withIcon
        ? _c(
            "div",
            {
              staticClass: "absolute inset-y-0 right-0 pr-3 flex items-center",
            },
            [_vm._t("icon")],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }